import { createApp } from 'vue'
import App from './App.vue'
import BootstrapVue3 from 'bootstrap-vue-3'
import router from "@/router";
import store from '@/store';
import 'bootstrap/dist/css/bootstrap.min.css'
import "bootstrap/dist/js/bootstrap.bundle.min.js"
import "bootstrap/dist/js/bootstrap.js"
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css'
import '@mdi/font/css/materialdesignicons.min.css'
// app.scss — after bootstrap, so the new design's styles override its classes
import '@/assets/style/app.scss';
import { vfmPlugin } from 'vue-final-modal'
import { LoadingPlugin } from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import Notifications from '@kyvg/vue3-notification'
import { initializeTheme } from '@/utils/theme';

// Initialize theme before mounting app
initializeTheme()

const app = createApp(App)
app.use(router)
app.use(store)
app.use(LoadingPlugin)
app.use(BootstrapVue3)
app.use(vfmPlugin)
app.use(Notifications)
app.mount('#app')



